function VerificaOrdiniRipetitivi() {

    var divOrdiniRip = $('#divOrdiniRipetitivi');
    if (divOrdiniRip && divOrdiniRip.length > 0) {
        var cbData = $('#cbData').dxCheckBox('instance');

        var dbData = $('#dbDataDesiderata').dxDateBox('instance');
        var dbDataValue = dbData.option('value');
        var hData = $('#hDataDesiderata');

        if (cbData.option('value') == true) {
            if (dbDataValue && dbDataValue != '01/01/0001 00:00:00') {
                hData.val(dateformat(cbData.option('min')));
                return true;
            }
        }
        else {
            return true;
        }
        dbData.option("isValid", false);
        return false;
    }
    return true;
}

function InizializzaCarrello() {
    try {
        if (typeof dataLayer !== "undefined") {
            var p = {};
            p.ga4event = "view_cart";

            mainController.CallServiceAsync("/Checkout/GetCartDetail", p)
                .then(function (r) {
                    if (r != null && r != undefined) {
                        var products = JSON.parse(r.JsonObject);
                        if (products != null && products != undefined) {
                            ga4.e_pushEventMulti(products, "view_cart", r.Valuta, "", r.TotaleOrdine, r.CodiceBuonoSconto);
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
    catch (error) {
        console.log(error);
    }

    ControllaErroreTotaliCarrello();

    $(window).resize(GrandezzaPopup);
}

function GrandezzaPopup() {
    var altezza = window.innerHeight;
    var larghezza = window.innerWidth;

    if (larghezza <= 850) {
        $('#popupDatiUtente').dxPopup('instance').option('height', '65%');
        $('#popupDatiUtente').dxPopup('instance').option('width', '60%');
    }
    else {
        $('#popupDatiUtente').dxPopup('instance').option('height', '55%');
        $('#popupDatiUtente').dxPopup('instance').option('width', '40%');
    }
}

function ProseguiCarrello(piva, sdi, pec, usertype, forzaAvanti) {

    var valid = false;

    try {
        if (forzaAvanti != true) {

            valid = VerificaOrdiniRipetitivi();

            if (valid == true) {
                if (piva && piva?.trim()?.length > 0) {
                    if (sdi?.length == 0 && pec?.length == 0) {

                        if (usertype && usertype?.length > 0 && parseInt(usertype) > 0) {
                            var div = $('#divTipoUtente');

                            if (div && div.length > 0) {
                                div.addClass('hidden');
                            }
                        }

                        $('#popupDatiUtente').dxPopup('instance').show();

                        valid = false;
                    }
                }
            }
        }
        else {
            valid = true;
        }

    } catch (ex) {
        console.error(ex);
    }
    return valid;
}

function popupDatiUtente_OnContentReady(e, usertype) {
    try {

        GrandezzaPopup();

        var chkCampi = $('#chkCampi');
        chkCampi[0].style.setProperty('display', 'none', 'important');

        var passaUsertype = true;
        if (usertype && usertype?.length > 0 && parseInt(usertype) > 0) {
            var div = $('#divTipoUtente');

            if (div && div.length > 0) {
                div.addClass('hidden');
                passaUsertype = false;
            }
        }

        var form = $('#fDatiMancantiUtente');
        form.submit((e) => {
            e.preventDefault();

            var txtSDI = $('#DatiMancantiSDI');
            var txtPEC = $('#DatiMancantiPEC');

            if (txtPEC.val()?.length > 0 || txtSDI.val()?.length > 0) {
                try {
                    waitingBS.Show();

                    var params = {
                        SDI: txtSDI.val(),
                        PEC: txtPEC.val()
                    };

                    if (passaUsertype == true) {
                        params.Usertype = $('#DatiMancantiUsertype').val();
                    }

                    mainController.CallServiceAsync(form.attr('action'), params)
                        .then((risp) => {
                            if (risp) {
                                if (risp.esito == Costanti.ESITO_OK) {
                                    var btn = document.getElementById('bconfermacarrello');

                                    btn.addEventListener('click', () => {
                                        return true;
                                    })

                                    setTimeout(() => {
                                        $('#fconfermacarrello').submit();
                                    }, 4000);
                                }
                                else {
                                    waitingBS.Hide();
                                }
                                mainController.NotifyMessageTimed(risp.responseText, risp.NotifyColor, 10000);
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            waitingBS.Hide();
                        })

                } catch (ex) {
                    console.error(ex);
                    waitingBS.Hide();
                }
            }
            else {
                txtSDI.addClass('is-invalid');
                txtPEC.addClass('is-invalid');
                chkCampi[0].style.setProperty('display', 'block', 'important');
            }
        });

    } catch (ex) {
        console.error(ex);
    }
}

function fDatiMancantiUtente_Validation() {
    var valid = true;

    try {
        var chkCampi = $('#chkCampi');
        var chkSDI = $('#msgsdi');

        chkCampi[0].style.setProperty('display', 'none', 'important');
        chkSDI[0].style.setProperty('display', 'none', 'important');

        var txtSDI = $('#DatiMancantiSDI');
        var txtPEC = $('#DatiMancantiPEC');

        txtSDI.removeClass('is-invalid');
        txtPEC.removeClass('is-invalid');

        if (txtPEC.val()?.length == 0 && txtSDI.val()?.length == 0) {
            txtSDI.addClass('is-invalid');
            txtPEC.addClass('is-invalid');
            chkCampi[0].style.setProperty('display', 'block', 'important');
            valid = false;
        }
        else {
            if (txtPEC.val()?.length > 0) {
                if (mainController.CheckEmail(txtPEC.val()) == false) {
                    txtPEC.addClass('is-invalid');
                    valid = false;
                }
            }

            if (txtSDI.val()?.length > 0) {
                if (CheckSdi(txtSDI) == false) {
                    txtSDI.addClass('is-invalid');
                    chkSDI[0].style.setProperty('display', 'block', 'important');
                    valid = false;
                }
            }
        }

    } catch (ex) {
        console.error(ex)
        valid = false;
    }

    return valid;
}

/**
 * 
 * @param {any} speseNonValide
 */
function BottoneConfermaCarrello(speseNonValide) {
    try {

        if (speseNonValide == true) {
            mainController.NotifyMessageTimed(mainController.GetLabel('lalertspesespedizionezero'), 'warning', 999999999);
            $('#bconfermacarrello').prop('disabled', true);
        }
        else {
            $('#bconfermacarrello').prop('disabled', false);
            if ($('#toast').dxToast('instance').option('type') == 'warning') {
                $('#toast').dxToast('instance')?.option('visible', false);
            }
        }
    } catch (ex) {
        console.log(ex);
    }
}

/**
 * 
 * @param {any} buonoTemp
 * @param {any} messaggioErroreCarrello
 * @param {any} speseContrassegno
 * @param {any} speseContrassegnoIvate
 */
function GestisciBuonoScontoCarrello(buonoTemp, messaggioErroreCarrello, speseContrassegno, speseContrassegnoIvate) {
    try {

        var tbBuonosconto = $('#tbBuonoSconto');
        if (tbBuonosconto.length > 0) {
            tbBuonosconto.attr('placeholder', mainController.GetLabel('lBuonoSconto'));

            if (buonoTemp && buonoTemp.length > 0) {
                tbBuonosconto.val(buonoTemp);
                $('#btnBuonoSconto').click();
            }

        }

        if (messaggioErroreCarrello && messaggioErroreCarrello.length > 0) {
            mainController.NotifyMessageTimed(messaggioErroreCarrello, Costanti.NOTIFY_COLOR_ERROR, 6000);
        }

        var tbGiftCard = $('#tbGiftCard');
        if (tbGiftCard.length > 0) {
            tbGiftCard.attr('placeholder', mainController.GetLabel('lInserisciCodice'));
        }


        if (speseContrassegno > 0) {
            $('#costocontr').val(speseContrassegno);
            $('#costocontrivato').val(speseContrassegnoIvate);
        }

        $('#fConcludiOrdine input').keydown((e) => {
            if (e.keyCode == 13) { // Enter
                e.preventDefault();
                return false;
            }
        });
    }
    catch (error) {
        console.log(error);
    }
}

function GestisciBoxRisparmioCarrello(valoreRisparmio) {
    try {

        // il box del risparmio si trova nel cartgrid e non qui
        // quindi per evitare un'altra chiamata (dato che ho già qui il dato del risparmio) lo gestisco qui con javascript
        var risparmio = $('#TotRisparmio')[0];

        if (risparmio != null && risparmio != undefined) {
            if (valoreRisparmio && valoreRisparmio.length > 0) {
                $('#pRisparmio').removeClass('hidden');
                risparmio.innerHTML = risparmio.innerHTML.replace('{0}', valoreRisparmio);
            }
            else {
                $('#pRisparmio').addClass('hidden');
            }
        }
        else {
            $('#pRisparmio').addClass('hidden');
        }

    } catch (ex) {
        console.log(ex);
    }
}

/**
 * 
 * @param {any} sender
 */
function ApplicaCodice(sender) {

    var valorebuonosconto = '';
    var valoregiftcard = '';
    var controllo = true;

    var buonosconto = $('#tbBuonoSconto');
    var hbuonosconto = $('#hbuonosconto');

    if (buonosconto != null && buonosconto != undefined) {
        if (buonosconto.val() != null && buonosconto.val() != undefined && buonosconto.val() != "") {
            valorebuonosconto = buonosconto.val();
        }
        else if (hbuonosconto != null && hbuonosconto != undefined) {
            if (hbuonosconto.val() != null && hbuonosconto.val() != undefined && hbuonosconto.val() != "") {
                valorebuonosconto = hbuonosconto.val();
            }
            else if (sender == 'buonosconto') {
                buonosconto.addClass('is-invalid');
                controllo = false;
            }
        }
        else {
            buonosconto.addClass('is-invalid');
            controllo = false;
        }
    }

    var giftcard = $('#tbGiftCard');
    var hgiftcard = $('#hgiftcard');

    if (giftcard != null && giftcard != undefined) {
        if (giftcard.val() != null && giftcard.val() != undefined && giftcard.val() != "") {
            valoregiftcard = giftcard.val();
        }
        else if (hgiftcard != null && hgiftcard != undefined) {
            if (hgiftcard.val() != null && hgiftcard.val() != undefined && hgiftcard.val() != "") {
                valoregiftcard = hgiftcard.val();
            }
            else if (sender == 'giftcard') {
                giftcard.addClass('is-invalid');
                controllo = false;
            }
        }
        else {
            giftcard.addClass('is-invalid');
            controllo = false;
        }
    }

    if (controllo) {
        checkoutController.UsaCodiceSconto(valorebuonosconto, valoregiftcard);
    }
}

/**
 * 
 * @param {any} sender
 */
function RimuoviCodice(sender) {
    try {
        waitingBS.Show();

        var buonosconto = '';
        var giftcard = '';
        var controllo = true;

        if (sender == 'buonosconto') {
            $('#hbuonosconto').val('');
            $('#hFormBuonoSconto').val('');
            $('#buonosconto').val('');
            var gc = $('#hgiftcard');
            if (gc.val() != null && gc.val() != undefined) {
                giftcard = gc.val();
            }
        }
        else {
            giftcard = $('#hgiftcard').val();
            checkoutController.AnnullaPrenotazioneGiftCard(giftcard);
            $('#hgiftcard').val('')
            $('#hFormGiftCard').val('')
            giftcard = '';
            var bs = $('#hbuonosconto');
            if (bs.val() != null && bs.val() != undefined) {
                buonosconto = bs.val();
            }
        }
        if (controllo) {
            mainController.RefreshTotali(0, buonosconto, true, giftcard);
        }
    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
    }
}